const middleware = {}

middleware['auth-check'] = require('../middleware/auth-check.js')
middleware['auth-check'] = middleware['auth-check'].default || middleware['auth-check']

middleware['trailingSlashRedirect'] = require('../middleware/trailingSlashRedirect.js')
middleware['trailingSlashRedirect'] = middleware['trailingSlashRedirect'].default || middleware['trailingSlashRedirect']

export default middleware
